import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'PAY_TYPE_ALL',
        delete: 'PAY_TYPE_DELETE'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'pay_type',
        label: 'pay_type',
        minWidth: '80px'
      }, {
        prop: 'name',
        label: 'name',
        minWidth: '120px'
      }, {
        prop: 'icon_url',
        label: 'icon_url',
        minWidth: '120px'
      }, {
        prop: 'icon_url',
        label: 'icon_url',
        minWidth: '180px',
        render: function render(_ref) {
          var row = _ref.row;
          return row.icon_url.indexOf('static') != -1 ? h("el-image", {
            "attrs": {
              "src": _this2.$env.VUE_APP_PIC + row.icon_url,
              "fit": "cover",
              "preview-src-list": [_this2.$env.VUE_APP_PIC + row.icon_url],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]) : h("el-image", {
            "attrs": {
              "src": row.icon_url,
              "fit": "cover",
              "preview-src-list": [row.icon_url],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "attrs": {
              "className": "el-icon-picture-outline"
            }
          })])]);
        }
      }, {
        prop: 'json_set',
        label: 'json_set',
        minWidth: '220px',
        formatter: function formatter(row) {
          return JSON.stringify(row.json_set);
        }
      }, {
        prop: 'ctime',
        label: 'ctime',
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this3 = this;

      return function (_ref2) {
        var row = _ref2.row;
        return [].concat(_toConsumableArray(_this3.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this3.edit(row.pay_type);
          }
        }], [])), _toConsumableArray(_this3.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this3.$t('confirm_delete_info'),
          action: function action() {
            return _this3.delete(row.pay_type);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this4 = this;

      var h = this.$createElement;
      return [{
        prop: 'start_time',
        label: 'start_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.start_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: 'end_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.end_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/page', ['closeBy']))
};